import React from 'react';
import { InspectionLabelScore } from '../../../../../common/src/domain/customInspectionTypes/inspectionLabel/common/InspectionLabelScore';
import aImage from './assets/a.png';
import aToGAImage from './assets/aToGA.png';
import aToGBImage from './assets/aToGB.png';
import aToGCImage from './assets/aToGC.png';
import aToGDImage from './assets/aToGD.png';
import aToGEImage from './assets/aToGE.png';
import aToGFImage from './assets/aToGF.png';
import aToGGImage from './assets/aToGG.png';
import aToGxImage from './assets/aToGx.png';
import bImage from './assets/b.png';
import cImage from './assets/c.png';
import dImage from './assets/d.png';
import eImage from './assets/e.png';
import fImage from './assets/f.png';
import gImage from './assets/g.png';
import nothingImage from './assets/nothing.png';

export function getOverallScoreImage(droneLabelScore?: InspectionLabelScore | null) {
    switch (droneLabelScore) {
        case 'A':
            return <img width="350px" src={String(aToGAImage)} />;
        case 'B':
            return <img width="350px" src={String(aToGBImage)} />;
        case 'C':
            return <img width="350px" src={String(aToGCImage)} />;
        case 'D':
            return <img width="350px" src={String(aToGDImage)} />;
        case 'E':
            return <img width="350px" src={String(aToGEImage)} />;
        case 'F':
            return <img width="350px" src={String(aToGFImage)} />;
        case 'G':
            return <img width="350px" src={String(aToGGImage)} />;
        default:
            return <img width="350px" src={String(aToGxImage)} />;
    }
}

export function getSubScoreImage(droneLabelScore?: InspectionLabelScore | null) {
    switch (droneLabelScore) {
        case 'A':
            return <img width="200px" style={{ paddingTop: '10px' }} src={String(aImage)} />;
        case 'B':
            return <img width="200px" style={{ paddingTop: '10px' }} src={String(bImage)} />;
        case 'C':
            return <img width="200px" style={{ paddingTop: '10px' }} src={String(cImage)} />;
        case 'D':
            return <img width="200px" style={{ paddingTop: '10px' }} src={String(dImage)} />;
        case 'E':
            return <img width="200px" style={{ paddingTop: '10px' }} src={String(eImage)} />;
        case 'F':
            return <img width="200px" style={{ paddingTop: '10px' }} src={String(fImage)} />;
        case 'G':
            return <img width="200px" style={{ paddingTop: '10px' }} src={String(gImage)} />;
        default:
            return <img width="200px" style={{ paddingTop: '10px' }} src={String(nothingImage)} />;
    }
}
